var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1337 9.00883C13.125 8.01758 13.75 7.18758 13.75 5.93758C13.75 4.5138 12.8722 3.23739 11.5427 2.72783C10.2133 2.21827 8.70726 2.58104 7.75562 3.64008C7.61178 3.77443 7.38855 3.7747 7.24438 3.64071C6.29282 2.58175 4.78696 2.21895 3.45755 2.72834C2.12813 3.23774 1.25028 4.51391 1.25 5.93758C1.25 7.37508 2.1875 8.43758 3.125 9.37508L6.58437 12.7263C6.81552 12.9749 7.1378 13.1187 7.47716 13.1249C7.81652 13.131 8.14378 12.9989 8.38375 12.7588C8.63226 12.51 8.77164 12.1725 8.77117 11.8208C8.7707 11.4691 8.63042 11.132 8.38125 10.8838C8.71002 11.2474 9.2124 11.4002 9.68795 11.2813C10.1635 11.1624 10.5348 10.7911 10.6537 10.3155C10.7727 9.83999 10.6198 9.3376 10.2563 9.00883C10.5052 9.25783 10.8429 9.39771 11.195 9.39771C11.5471 9.39771 11.8848 9.25783 12.1337 9.00883C12.6217 8.52071 12.6217 7.72946 12.1337 7.24133L10.9581 6.06508C10.6756 5.78246 10.2924 5.62368 9.89281 5.62368C9.49322 5.62368 9.11 5.78246 8.8275 6.06508L7.75875 7.13383C7.27063 7.62181 6.47937 7.62181 5.99125 7.13383C5.50327 6.64571 5.50327 5.85446 5.99125 5.36633L7.75562 3.64008",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.9f3d3536c54195ae8535b3a28abcaf13.svg";
export { ForwardRef as ReactComponent };